<template>
  <div class="tes-card pa-7">
    <v-row>
      <v-col>
        <h1 class="tes-card__title">
          {{$t('pages.changeTariff.title')}}
        </h1>
        <p class="mt-5 font-weight-medium mt-4 mb-0"
        :class="currentLocale === 'ru' ? 'helvetica-medium' : 'rubik-medium'">
          {{$t('client')}}
        </p>
        <p class="mb-0 mt-5"
          :class="currentLocale === 'ru' ? 'helvetica-roman' : 'rubik-roman'">
          {{$t('pages.changeTariff.title')}}
        </p>
        <p><sup class="star">*</sup> - {{$t('requireFields')}}</p>
        <v-row class="mt-7">
          <v-col
            :cols="12"
            :sm="4"
            :md="3"
            :lg="2"
            :xl="2"
            class="col col-title"
            >{{$t('personalAccount')}}:</v-col
          >
          <v-col class="col" :cols="12" :sm="8" :md="7" :lg="6" :xl="6">
            <personal-account-select
              v-model="selectedAccount"
              :is-local="true"
              :only-is-owner="true"
              :disabled="loading"
            >
            </personal-account-select>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            :cols="12"
            :sm="4"
            :md="3"
            :lg="2"
            :xl="2"
            class="col col-title"
            >{{$t('pages.changeTariff.meteringDevice')}}:</v-col
          >
          <v-col class="col" :cols="12" :sm="8" :md="7" :lg="6" :xl="6">
            <v-select
              :items="devices"
              item-text="meterNumber"
              return-object
              v-model="device"
              :loading="loading"
              :disabled="loading"
              outlined
            >
              <template v-slot:item="{ item }">{{
                `${item.serviceName} №${item.meterNumber}`
              }}</template>
              <template v-slot:selection="{ item }">{{
                `${item.serviceName} №${item.meterNumber}`
              }}</template>
            </v-select>
          </v-col>
        </v-row>
      </v-col>
      <change-tariff-notification v-if="isTariffExists" :textNotification="textNotification"/>

      <change-tariff-zonality-notification
        v-if="device && device.zonalityCount < 2 && device.calcMethod != 0"
      />
    </v-row>
    <old-application
      v-if="device && device.calcMethod == 0 && !isTariffExists"
      :device="device"
      :selectedAccount="selectedAccount"
    />
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
      v-else-if="device && infoAboutPU.canChangeTariff === true && !isTariffExists"
    >
      <v-divider class="divider d-flex"></v-divider>

      <v-row class="row-phone">
        <v-col class="col col-title" :cols="6" :sm="3" :md="3" :lg="2" :xl="2"
          >{{$t('phone')}}:
          <sup class="star">*</sup>
        </v-col>
        <v-col class="col" :cols="6" :sm="3" :md="3" :lg="2" :xl="2">
          <v-select
            :items="actualPhones"
            :rules="phoneRules"
            item-text="phoneNumber"
            item-value="phoneNumber"
            v-model="phone"
            :disabled="loading"
            outlined
          >
          </v-select>
        </v-col>
        <v-col class="col col-title" :cols="6" :sm="3" :md="3" :lg="2" :xl="2"
          >{{$t('pages.changeTariff.currentMethod')}}:
        </v-col>
        <v-col class="col" :cols="6" :sm="3" :md="3" :lg="2" :xl="2">
          <v-text-field
            outlined
            :disabled="true"
            v-model="device.puCalcMethodText"
          >
          </v-text-field>
        </v-col>
        <v-col class="col col-title" :cols="6" :sm="3" :md="3" :lg="2" :xl="2"
          >{{$t('pages.changeTariff.lastDate')}}:
        </v-col>
        <v-col class="col" :cols="6" :sm="3" :md="3" :lg="2" :xl="2">
          <v-text-field outlined :disabled="true" v-model="dateChanged">
          </v-text-field>
        </v-col>
      </v-row>
      <v-divider class="divider"></v-divider>
      <change-tariff-mark-notification
        v-if="device && device.isTwoNonAdmission"
      />

      <div v-if="!isTariffExists && device.zonalityCount >= 2">
        <v-row
          v-if="checkDate(device.installDate)"
          align="center"
          justify="center"
          class="mt-5"
        >
          <v-col cols="4" class="pa-10 upload-container text-center">
            <strong>{{$t('client')}}</strong><br />
                  {{$t('pages.changeTariff.infoAgree')}}
          </v-col>
          <v-col cols="1"> </v-col>
          <v-col class="pa-6 upload-container" cols="5">
            <file-form
              class="mt-10 mb-10"
              fileType="0"
              @transferData="setFile"
              :income="files['0']"
            >
              <div v-if="!validFile" class="red--text py-3">
                <v-icon small class="red--text"
                  >mdi-alert-circle-outline</v-icon
                >
                {{$t('pages.changeTariff.needFile')}}
              </div></file-form
            >
            <v-divider></v-divider>
            <p class="mt-5 mb-5">
              {{$t('maxSizeFile')}}- 5 Мб {{$t('fileFormats')}}: .pdf,
              .jpg, .tif, .mpg, .bmp, .png, .gif
            </p>
            <v-divider></v-divider>
          </v-col>
        </v-row>

        <h2 class="change-tariff-electricity__title-2">{{$t('pages.changeTariff.inputIndication')}}  </h2>

        <div v-if="device && device.zonalityCount === 2">
          <v-row>
            <v-col
              class="col col-title"
              :cols="5"
              :sm="4"
              :md="3"
              :lg="2"
              :xl="2"
            >
              {{$t('pages.changeTariff.day')}}:
              <sup class="star">*</sup>
            </v-col>
            <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
              <v-text-field
                type="number"
                v-model="day"
                :rules="dayRules"
                min="0"
                :disabled="loading"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="col col-title"
              :cols="5"
              :sm="4"
              :md="3"
              :lg="2"
              :xl="2"
            >
              {{$t('pages.changeTariff.night')}}:
              <sup class="star">*</sup>
            </v-col>
            <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
              <v-text-field
                type="number"
                v-model="night"
                :rules="nightRules"
                min="0"
                :disabled="loading"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <!--<v-row>
            <v-col
              class="col col-title"
              :cols="5"
              :sm="4"
              :md="3"
              :lg="2"
              :xl="2"
            >
              Сумма:
            </v-col>
            <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
              <v-text-field
                type="number"
                v-model="sum"
                :rules="sumRules"
                min="0"
                :disabled="loading || !device.sumScale"
                outlined
                @change="validateField"
              ></v-text-field>
            </v-col>
          </v-row>-->
        </div>
        <div v-if="device && device.zonalityCount === 3">
          <v-row>
            <v-col
              class="col col-title"
              :cols="5"
              :sm="4"
              :md="3"
              :lg="2"
              :xl="2"
            >
              Пик:
              <sup class="star">*</sup>
            </v-col>
            <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
              <v-text-field
                type="number"
                v-model="pick"
                :rules="dayRules"
                min="0"
                :disabled="loading"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="col col-title"
              :cols="5"
              :sm="4"
              :md="3"
              :lg="2"
              :xl="2"
            >
              {{$t('pages.changeTariff.halfPeak')}}:
              <sup class="star">*</sup>
            </v-col>
            <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
              <v-text-field
                type="number"
                v-model="halfPick"
                :rules="nightRules"
                min="0"
                :disabled="loading"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="col col-title"
              :cols="5"
              :sm="4"
              :md="3"
              :lg="2"
              :xl="2"
            >
              {{$t('pages.changeTariff.night')}}:
            </v-col>
            <v-col class="col" :cols="6" :sm="5" :md="4" :lg="3" :xl="2">
              <v-text-field
                v-model="night"
                :rules="sumRules"
                min="0"
                :disabled="loading"
                outlined
                @change="validateField"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-row class="radio-btns">
          <v-col>
            <h3 class="radio-btns-title">
              {{$t('pages.changeTariff.typeTariff')}}:
              <sup class="star">*</sup>
            </h3>

            <v-radio-group
              v-model="chosenTariff"
              :rules="radioConfirmRules"
              :disabled="loading"
              column
            >
              <v-radio
                v-for="(chosenTariff, key) in tariffForms"
                :key="key"
                :label="chosenTariff"
                :value="chosenTariff"
                color="#33cc33"
              >
              </v-radio>
            </v-radio-group>
          </v-col>
          <!--<v-col v-if="device && device.zonalityCount === 2">
            <h3 class="radio-btns-title">
              {{$t('pages.changeTariff.selectReportOption')}}:
              <sup class="star">*</sup>
            </h3>

            <v-radio-group
              v-model="selectedReportingOption"
              :rules="radioRules"
              :disabled="loading"
              column
            >
              <v-radio
                v-for="(selectedReportingOption, key) in reportingOptions"
                :key="key"
                :label="selectedReportingOption"
                :value="selectedReportingOption"
                color="#33cc33"
              >
              </v-radio>
            </v-radio-group>
          </v-col>-->
        </v-row>
      </div>
      <v-row>
        <v-col :cols="6">
          <v-btn
            @click="preview"
            class="btn btn--blue"
            :disabled="
              isTariffExists || device.zonalityCount < 2 || !valid || !validFile
            "
            :loading="loading"
            >{{$t('buttons.view')}}</v-btn
          >
        </v-col>
        <v-col class="text-right" :cols="6">
          <v-btn @click="clear" class="btn btn--white" :loading="loading"
            >{{$t('buttons.cancel')}}</v-btn
          >
          <v-btn
            @click="save"
            :disabled="
              isTariffExists || device.zonalityCount < 2 || !valid || !validFile
            "
            class="btn btn--green"
            :loading="loading"
            >{{$t('buttons.save')}}</v-btn
          >
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import PersonalAccountSelect from "../../../components/common/PersonalAccountSelect";
import ChangeTariffNotification from "../../../components/statements/change-tariff-electricity/ChangeTariffNotification.vue";
import ChangeTariffZonalityNotification from "../../../components/statements/change-tariff-electricity/ChangeTariffZonalityNotification.vue";
import FileForm from "../../../components/statements/components/partial/FileForm";
import { mapState, mapGetters } from "vuex";
import ChangeTariffMarkNotification from "../../../components/statements/change-tariff-electricity/ChangeTariffMarkNotification.vue";
import OldApplication from "../../../components/application/change-tariff/index.vue";

export default {
  layout: "main",
  components: {
    PersonalAccountSelect,
    ChangeTariffNotification,
    FileForm,
    ChangeTariffZonalityNotification,
    ChangeTariffMarkNotification,
    OldApplication,
  },
  data: () => ({
    files: {
      0: null,
    },
    isTariffExists: false,
    alert: false,
    selectedAccount: null,
    device: null,
    wayForTransmittingReading: null,
    chosenTariff: null,
    day: null,
    night: null,
    sum: null,
    pick: null,
    halfPick: null,
    phone: null,
    valid: false,
    selectedReportingOption: null,
    loading: false,
  }),
  methods: {
    validate() {
      return !!this.$refs.form.validate();
    },
    save() {
      if (!this.validate()) return false;
      if (this.checkDate(this.device.installDate)) {
        if (this.files["0"] === null) {
          return false;
        }
      }
      this.loading = true;
      this.$store
        .dispatch(
          "statements/setApplicationForChangeTariff",
          this.getChangeTariffInfo
        )
        .then((isSuccess) => {
          this.loading = false;
          this.$store.dispatch("statements/getIsTarriffExists");
          if (isSuccess) {
            this.clear();
            this.$router.push("/statements/history");
          }
        });
    },
    preview() {
      if (!this.validate()) return false;
      if (this.checkDate(this.device.installDate)) {
        if (this.files["0"] === null) {
          return false;
        }
      }
      this.loading = true;
      this.$store
        .dispatch(
          "statements/getApplicationForChangeTariff",
          this.getChangeTariffInfo
        )
        .then((response) => {
          this.loading = false;

          const key = Math.random() * Math.random() * Math.random();
          localStorage.setItem(key, response);

          let routeData = this.$router.resolve({
            path: "/preview",
            query: {
              title: "Заявление на смену тарифа на электроэнергию",
              key,
            },
          });

          window.open(routeData.href, "_blank");
        });
    },
    clear() {
      this.wayForTransmittingReading = null;
      this.chosenTariff = null;
      this.selectedReportingOption = null;
      this.day = null;
      this.night = null;
      this.sum = null;
      this.pick = null;
      this.halfPick = null;
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    checkDate(date) {
      let installDate = new Date(date);
      let oldDate = new Date("10.26.2014");

      if (installDate <= oldDate) return true;

      return false;
    },
    setFile(payload) {
      console.log(payload);
      if (!payload.fileBytes) {
        this.files["0"] = null;
      } else {
        this.files[payload.fileType] = payload;
      }
      console.log(this.files);
    },
    validateField(e) {
      if (e && isNaN(e)) {
        if (this.device.zonalityCount === 2) this.sum = null;
        else if (this.device.zonalityCount === 3) this.night = null;
      }
    },
  },
  computed: {
    ...mapState("account", ["actualPhones"]),
    ...mapState("indication", {
      devices: (state) =>
        state.devices.filter(
          (i) => i.measure && i.measure.trim().toLowerCase() === "квт*час"
        ),
    }),
    ...mapState("statements", ["infoAboutPU"]),
    ...mapGetters("locale",["currentLocale"]),
    getChangeTariffInfo() {
      return {
        userId: this.$store.state.account.userSettings.userGuid,
        domHoz: this.selectedAccount.domHoz,
        meterNumber: this.device.meterNumber,
        wayForTransmittingReadings: this.wayForTransmittingReading,
        tariffType: this.infoAboutPU.tariffType,
        mkd: this.infoAboutPU.mkd,
        dayValue: this.day ? this.day.replace(/\./, ",") : null,
        nightValue: this.night ? this.night.replace(/\./, ",") : null,
        sum: this.sum ? this.sum.replace(/\./, ",") : null,
        pickValue: this.pick ? this.pick.replace(/\./, ",") : null,
        halfPickValue: this.halfPick ? this.halfPick.replace(/\./, ",") : null,
        chosenTariff: this.chosenTariff,
        selectedReportingOption: "Отдельно по зонам суток",
        zonalityCount: this.device.zonalityCount,
        sumScale: this.device.sumScale,
        phone: this.phone,
        files: this.files["0"],
      };
    },
    validFile() {
      if (this.checkDate(this.device.installDate)) {
        if (this.files["0"] === null) {
          return false;
        }
      }
      return true;
    },
    dateChanged() {
      if (this.device)
        return new Date(this.device.tariffChangedDate).toLocaleDateString();
      else return null;
    },
    tariffForms() {
      if (this.device.calcMethod == 2) {
        return [this.$t('pages.changeTariff.tariffD')]
      }
      else if (this.device.calcMethod == 1) {
        return [this.$t('pages.changeTariff.tariffNotD')]
      }
      else return [
        this.$t('pages.changeTariff.tariffD')
      ]
    },
    reportingOptions() {
      return [
      this.$t('pages.changeTariff.dayZones'),
      this.$t('pages.changeTariff.sumIndication'),
      ]
    },
    dayRules() {
      return [
      (v) => !!v || this.$t('rules.inputCorrectData'),
      (v) => +v >= 0 || this.$t('rules.notNegativeNumber'),
      (v) => typeof +v === "number" || this.$t('rules.needNumber'),
      ]
    },
    nightRules() {
      return [
      (v) => !!v || this.$t('rules.inputCorrectData'),
      (v) => +v >= 0 || this.$t('rules.notNegativeNumber'),
      (v) => typeof +v === "number" || this.$t('rules.needNumber'),
      ]
    },
    sumRules(){
      return [
      (v) => +v >= 0 || this.$t('rules.inputCorrectData'),
      (v) => typeof +v === "number" || this.$t('rules.needNumber'),
      ]
    },
    phoneRules(){ return [(v) => !!v || this.$t('rules.selectPhone')]},
    radioConfirmRules() { return [(v) => !!v || this.$t('rules.selectOptionConfirm')]}
  },
  watch: {
    selectedAccount(value) {
      this.$store.dispatch("indication/loadDevices", {
        domHoz: value.domHoz,
      });
      this.device = null;
    },
    device(value) {
      this.clear();
      this.isTariffExists = false;

      if (value) {
        this.loading = true;
        this.$store
          .dispatch("statements/getInfoAboutPU", {
            domHoz: this.selectedAccount.domHoz,
            idPribor: value.idPribors,
            numberPU: value.meterNumber,
            userId: this.$store.state.account.userSettings.userGuid,
          })
          .then((data) => {
            this.alert = data.canChangeTariff === false;
          });

        this.loading = true;
        this.$store
          .dispatch("statements/getIsTarriffExistsForPribor", {
            meterNumber: value.meterNumber,
          })
          .then((result) => {
            if (!result.success) {
              if (
                result.message.includes(
                  "Уважаемый клиент! В этом месяце вы уже подавали заявление на изменение вида тарифа на электроэнергию по данному прибору учета"
                )
              ) {
                this.isTariffExists = true;
                this.textNotification = result.message.replace(
                  "Уважаемый клиент!",
                  ""
                );
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$store.commit("SET_INFO_ABOUT_PU", {});
      }
      setTimeout(() => {
        this.validate();
      }, 500);
    },
    selectedReportingOption(value){
      if(value && this.device && this.device.zonalityCount === 2){
         if(value === this.$t('pages.changeTariff.sumIndication') && this.chosenTariff === this.$t('pages.changeTariff.tariffD')){
             this.chosenTariff = this.$t('pages.changeTariff.tariffNotD');
         }
      }
    },
    chosenTariff(value){
      if(value && this.device && this.device.zonalityCount === 2){
         if(value === this.$t('pages.changeTariff.tariffD') && this.selectedReportingOption === this.$t('pages.changeTariff.sumIndication')){
             this.selectedReportingOption = this.$t('pages.changeTariff.dayZones');
         }
      }
    }
  },
  created() {
    this.$store.dispatch("account/getActualPhones");
  },
};
</script>

<style lang="scss" scoped>
.change-tariff-electricity {
  width: 100%;
  position: relative;
  padding: 23px 17px 23px 22px;
  background-color: white;
  border-radius: 5px;

  &__br {
    display: block;
    font-size: 20px;
  }

  &__title {
    @extend %h1;
  }

  &__title-2 {
    color: #333333;
    font-weight: bold;
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 22px;
  }

  &__important {
    display: block;
    @extend %important-text;
  }

  &__text {
    display: block;
    @extend %text;
    font-style: italic;
  }

  &__marker {
    display: block;
    @extend %marker-text;
    margin-bottom: 21px;
  }

  &__form {
    position: relative;
    width: 100%;
  }
}

.btn {
  &--blue {
    @extend %b-btn;
    margin: 8px 8px 8px 0;
  }

  &--white {
    @extend %w-btn;
    margin: 8px 0 8px 8px;
  }

  &--green {
    @extend %g-btn;
    margin: 8px 0 8px 16px;
  }
}

.divider {
  background: #999;
}

.star {
  color: #ff9933;
}

.radio-btns-title,
.col col-title {
  font-weight: 500;
  font-size: 18px;
  color: #4d4d4d;
}

.radio-btns-title {
  display: block;
  margin: 25px 0;
}

.radio-btns {
  margin-bottom: 30px;
}

.radio-btns-info {
  display: block;
  @extend %marker-text;
  color: $main-orange;
  margin-top: 21px;
}

.col {
  padding: 0 12px;

  &-title {
    @extend %important-text;
    width: 300px;
    align-self: center;
    margin-bottom: 30px;
  }
}

.row-phone {
  margin: 30px 0 12px 0;
}

.v-radio {
  margin-right: 0;

  & + & {
    margin-top: 7px;
  }
}

.col-alert {
  display: flex;
  align-items: center;

  &-text {
    margin-left: 10px;
    color: white;
  }

  &-right {
    justify-content: flex-end;
  }
}

.upload-container {
  border: 5px solid lightgray;
}
</style>
